import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';

export interface SendSmsRequest {
  phone: string;
  message: string;
  refkey: string;
}

export interface SendSmsResponse {
  success: boolean;
  message?: string;
}

export const sendSms = async (
  data: SendSmsRequest
): Promise<SendSmsResponse> => {
  const response = await XHRAuthorizedClient.post<SendSmsResponse>(
    ENDPOINTS.sms.send,
    data
  );

  return response.data;
};
